import client from './client';

/**
 * Fetch the current user's achievements and SpudCoin balance.
 * @returns {Promise<{spudcoin_balance:number,total_earned:number,total_available:number,achievements:Array}>}
 */
export const getAchievements = async () => {
    const response = await client.get('/achievements');
    return response.data;
};
